function initEscape() {
  const searchOverlays = document.querySelectorAll( '.search-overlay' );

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    let isEscape = false;
    if ('key' in evt) {
      isEscape = (
        evt.key === 'Escape' || evt.key === 'Esc'
      );
    } else {
      isEscape = (
        evt.keyCode === 27
      );
    }
    if (isEscape) {
      if (searchOverlays.length) {
        unActiveAll( searchOverlays );
      }
    }
  };
}

function unActiveAll(querySelector) {
  if (querySelector) {
    [...querySelector].forEach( (element) => {
      element.classList.remove( 'open' );
    } );
  }
}

export default {
  init() {
    initEscape();
  },
};